import React, { useContext } from 'react';
import {
    Box,
    CardHeader,
    Paper
} from '@mui/material';
import { CommonContext, MasterDataContext } from '../../context';
import FilterBar from './FilterBar';
import Loader from '../common/Loader';
import AlertMessage from '../common/AlertMessage';

const MasterDataView = () => {
    const {
        isLoading,
    } = useContext(MasterDataContext);
    const { openAlert } = useContext(CommonContext);

    return (
        <Box className='main-screen' sx={{ p: 2 }}>
            {isLoading && <Loader />}
            {openAlert && <AlertMessage />}


            <Box className="component-header" sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <CardHeader title="Master Data" />
            </Box>

            <Paper sx={{ mb: 2, p: 2 }}>
                <FilterBar />
            </Paper>
        </Box>
    );
};

export default MasterDataView;
